import { useState } from "react";
import { useLocation } from "react-router-dom";
import DynamicMaster from "../../Components/DynamicMaster/DynamicMaster";
import { useAuthStore } from "../../AuthStore/AuthStore";


export default function DocumentTypeMaster() {

  // const { userId,currentRoleId,permissionRecord } = useAuthStore();
   

    return (
        <>
          <DynamicMaster id={5} dashboardId={5} />
        </>
      );



}